import React, { useState } from "react";
import "./contactUsCard.scss";
import {
  Button,
  Collapse,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  Stack,
  TextField,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import dateFormat from "dateformat";
import QuillEditor from "../../components/quillEditor/QuillEditor";
import brandStore from "../../stores/brandStore";
import contactUsStore from "../../stores/contactUsStore";
import KeyboardArrowDownRoundedIcon from "@mui/icons-material/KeyboardArrowDownRounded";

const ContactUsCard = ({ item }) => {
  const [open, setOpen] = useState(false);
  const BrandStore = brandStore();
  const ContactUsStore = contactUsStore();
  const [sendLoading, setSendLoading] = useState(false);

  const [expanded, setExpanded] = React.useState(false);

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  const [subject, setSubject] = useState(
    `${item.firstName} ${item.lastName} - `
  );
  const [message, setMessage] = useState("");

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSendMail = async () => {
    setSendLoading(true);
    const res = await ContactUsStore.updateReplyContactUs({
      _id: item._id,
      emailTo: item.email,
      subject,
      message,
      customerName: item.firstName + " " + item.lastName,
      brandName: BrandStore.brand.brandName,
    });

    if (res) {
      setOpen(false);
    }
    setSendLoading(false);
  };

  return (
    <div className="contact-us-card">
      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
        <DialogTitle>
          Reply To {item.firstName} {item.lastName}
        </DialogTitle>
        <DialogContent>
          <Stack spacing={1}>
            <h3>Message</h3>
            <div>{item.message}</div>
          </Stack>
          <div style={{ marginTop: "20px", display: "flex" }}>
            <b>To:</b>{" "}
            <p style={{ fontWeight: 500, marginLeft: "5px" }}>{item.email}</p>
          </div>
          <Stack spacing={2}>
            <TextField
              autoFocus
              margin="dense"
              id="name"
              label="Subject"
              type="email"
              fullWidth
              variant="standard"
              required
              value={subject}
              onChange={(e) => setSubject(e.target.value)}
            />
            <div>
              <b>Our Message *</b>
              <QuillEditor
                id="productContent"
                placeholder=" Write to reply..."
                value={message}
                onChange={(value) => setMessage(value)}
              />
            </div>
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <LoadingButton loading={sendLoading} onClick={handleSendMail}>
            Send
          </LoadingButton>
        </DialogActions>
      </Dialog>
      <div className="create-at">
        {dateFormat(new Date(item.created_at), "dd, mmm yyyy")}
      </div>
      <div className="customer-name">
        {item.firstName} {item.lastName}
      </div>
      <div className="customer-email">{item.email}</div>
      <div className="customer-phone-no">{item.phoneNo}</div>
      <div className="customer-message">
        <div className="title">Message</div>
        <div className="content">{item.message}</div>
      </div>
      <div className="replied">
        {item.replied_at ? (
          <div className="replied-at">
            - {dateFormat(new Date(item.replied_at), "dd, mmm yyyy")}{" "}
            <IconButton onClick={handleExpandClick}>
              <KeyboardArrowDownRoundedIcon
                className="icon"
                style={{
                  transform: !expanded ? "rotate(0deg)" : "rotate(180deg)",
                }}
              />
            </IconButton>
          </div>
        ) : (
          <Button onClick={handleClickOpen}>Reply</Button>
        )}
      </div>
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <div style={{ fontWeight: 700, fontSize: "15px" }}>Our Reply</div>
        <div
          style={{ marginTop: "5px" }}
          dangerouslySetInnerHTML={{
            __html: item.replied,
          }}
        />
      </Collapse>
    </div>
  );
};

export default ContactUsCard;
